import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SearchBar from "./SearchBar";
import PixeloreLogo from "../../assets/images/pixelorelogo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [hideSearch, setHideSearch] = useState(false);
  const [isScrolledDown, setIsScrolledDown] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleDropdown = (menuName) => {
    setOpenDropdown((prev) => (prev === menuName ? null : menuName));
  };

  const isMobile = window.innerWidth < 1024;

  useEffect(() => {
    if (!isMobile) return;

    const onScroll = () => {
      const scrollY = window.scrollY;

      if (scrollY < 50) {
        setHideSearch(false);
        setIsScrolledDown(false);
      } else {
        setHideSearch(true);
        setIsScrolledDown(true);
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [isMobile]);

  return (
    <nav className="sticky top-0 z-50">
      <div className="navbarmain">
        <div className="navlogo">
          <Link to="/">
            <img
              src={PixeloreLogo}
              className={`transition-all duration-300 ease-in-out pl-4 lg:pl-20 ${isMobile && isScrolledDown ? "h-12" : "h-16"}`}
              alt="pixelore logo"
            />
          </Link>
          <button className="navbutton" onClick={toggleMenu}>
            ☰
          </button>
        </div>

        <div className={`navbarcenter ${isOpen ? "block" : "hidden"} lg:flex lg:flex-wrap lg:w-auto`}>
          <ul className="">
            {/* Repeated menu structure simplified with reusable list */}
            {[
              {
                label: "Wiki",
                name: "wiki",
                items: [
                  { to: "/wiki/beginner", label: "Starter Guide" },
                  { to: "/wiki/quests", label: "Quest Guides" },
                  { to: "/wiki/skills", label: "Skills" },
                  { to: "/wiki/animalcare", label: "Animal Care" },
                  { to: "/wiki/lands", label: "Land & Specks" },
                  { to: "/wiki/pets", label: "Pet Guides" },
                  { to: "/wiki/endgame", label: "End Game" },
                  { to: "/wiki/events", label: "Live Ops" },
                  { to: "/wiki/changelogs", label: "Change Logs" },
                ],
              },
              {
                label: "Lookups",
                name: "lookups",
                items: [
                  { to: "/lookup/profit", label: "Profit Market" },
                  { to: "/lookup/items", label: "Items" },
                  { to: "/lookup/players", label: "Players" },
                  { to: "/lookup/lands", label: "Lands" },
                  { to: "/lookup/guilds", label: "Guilds" },
                ],
              },
              {
                label: "Tools",
                name: "tools",
                items: [
                  { to: "/tools/energy", label: "Energy" },
                  { to: "/tools/calculator", label: "Calculators" },
                  { to: "/tools/leaderboards", label: "Leaderboards" },
                ],
              },
              {
                label: "Avatars",
                name: "avatars",
                to: "/avatars",
              },
              {
                label: "Other",
                name: "other",
                items: [
                  { to: "/other/assets", label: "Pixel Assets" },
                  { to: "/other/calendar", label: "Pixels Calendar" },
                  { to: "/other/overlay", label: "Twitter Overlay" },
                ],
              },
            ].map((menu) => (
              <li key={menu.name} className="relative group w-full lg:w-auto">
                {menu.items ? (
                  <>
                    <button className="nav-link" onClick={() => isMobile && toggleDropdown(menu.name)}>
                      {menu.label} {isMobile ? "↡" : ""}
                    </button>
                    <div className={`${isMobile ? (openDropdown === menu.name ? "flex flex-col w-full" : "hidden") : "nav-section"}`}>
                      {menu.items.map((item) => (
                        <Link className="nav-line" to={item.to} key={item.to}>
                          {item.label}
                        </Link>
                      ))}
                    </div>
                  </>
                ) : (
                  <Link className="nav-link" to={menu.to}>
                    {menu.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div
          className={`search transition-all duration-300 ease-in-out ${
            isMobile && hideSearch ? "max-h-0 opacity-0 pointer-events-none" : "max-h-20 opacity-100"
          }`}
        >
          <SearchBar />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
